import { useLocales } from 'expo-localization';

import { getPreferredSupportedLocale } from '../utils/localization';

export const useSystemLocale = () => {
  const locales = useLocales();
  return getPreferredSupportedLocale(locales);
};
